<script>
  import Legend from "./legend/Legend.svelte";
  import SearchButton from "./search/SearchButton.svelte";
  import Map from "./Map.svelte";
  import Sidebar from "./sidebar/Sidebar.svelte";
  import WelcomePopup from "./WelcomePopup.svelte";

  let activeFeature;
  let position;
  export let welcomePopupVisible = true;
  export let legendLink;

  const onSelect = (event) => {
    activeFeature = event.detail.feature;
  };

  const setPosition = (event) => {
    position = event.detail.result;
  };

  const onClose = () => {
    activeFeature = null;
  };

  const closeWelcomePopup = () => {
    welcomePopupVisible = false;
  };
</script>

<main>
  <Map on:select={onSelect} {position} />
  <SearchButton on:select={setPosition} />
  {#if activeFeature}
    <Sidebar feature={activeFeature} on:close={onClose} />
  {/if}
  <Legend {legendLink} />
  {#if welcomePopupVisible}
    <WelcomePopup on:close={closeWelcomePopup} on:select={setPosition} />
  {/if}
</main>

<style>
  main {
    position: fixed;
    top: 100px;
    width: 100vw;
    height: calc(100vh - 100px);
    overflow: hidden;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
